export const Colors = {
  White: '#ffffff',

  Neutral5: '#f7f9fc',
  Neutral10: '#eff2f9',
  Neutral15: '#e7eaf4',
  Neutral20: '#d9deeb',
  Neutral25: '#F3F3F8',
  Neutral30: '#bec4d5',
  Neutral40: '#9fa6bb',
  Neutral50: '#828ba2',
  Neutral60: '#656e83',
  Neutral70: '#495163',
  Neutral80: '#303848',
  Neutral90: '#1e2532',
  Neutral100: '#0f141e',

  Blue10: '#eaf6ff',
  Blue20: '#c3e5fe',
  Blue30: '#92cdfc',
  Blue40: '#54aff8',
  Blue50: '#1a91f0',
  Blue60: '#1170cd',
  Blue70: '#10529b',
  Blue80: '#0f3871',
  Blue90: '#0c264c',
  Blue100: '#09162d',

  Indigo10: '#f1f2ff',
  Indigo20: '#dbdeff',
  Indigo30: '#bec2fe',
  Indigo40: '#9ba1fb',
  Indigo50: '#7a82f5',
  Indigo60: '#5660e8',
  Indigo70: '#343ecc',
  Indigo80: '#282b8f',
  Indigo90: '#1a1c6a',
  Indigo100: '#0e0f47',

  Green10: '#e7f4ed',
  Green20: '#c6e4d2',
  Green30: '#96d0ad',
  Green40: '#48ba75',
  Green50: '#339d5d',
  Green60: '#217d47',
  Green70: '#135c37',
  Green80: '#094025',
  Green90: '#042b18',
  Green100: '#01180d',

  Amber10: '#fff2cc',
  Amber20: '#fddb8c',
  Amber30: '#f9ba44',
  Amber40: '#ec930c',
  Amber50: '#cf760d',
  Amber60: '#a85a0e',
  Amber70: '#7f400d',
  Amber80: '#582c0c',
  Amber90: '#3e1d0a',
  Amber100: '#231007',

  Orange10: '#feebe3',
  Orange20: '#fdd2c0',
  Orange30: '#fbb092',
  Orange40: '#f68559',
  Orange50: '#ee571d',
  Orange60: '#bf4213',
  Orange70: '#8b3211',
  Orange80: '#5e240e',
  Orange90: '#3b180b',
  Orange100: '#1c0c06',

  Red10: '#ffeaec',
  Red20: '#ffd0d5',
  Red30: '#ffacb5',
  Red40: '#fe7d8b',
  Red50: '#fb4458',
  Red60: '#da0c22',
  Red70: '#a10e1d',
  Red80: '#6f0e19',
  Red90: '#470c12',
  Red100: '#24090c',

  Beige10: '#f3f1eb',
  Beige20: '#e1ddd2',
  Beige30: '#cbc3b3',
  Beige40: '#afa58f',
  Beige50: '#968a70',
  Beige60: '#776d59',
  Beige70: '#575041',
  Beige80: '#3c372d',
  Beige90: '#27241d',
  Beige100: '#15130f',
} as const

type FindVariableTones<T> = T extends `${infer C}100` ? C : never
export type ToneName = Lowercase<FindVariableTones<keyof typeof Colors>>
export type ToneNames = FindVariableTones<keyof typeof Colors>
